package com.yogaaicoach.pages.auth

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.yogaaicoach.pages.auth.firebase.FirebaseService
import com.yogaaicoach.pages.auth.firebase.sendPasswordResetEmailPlatform
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class ForgotPasswordViewModel(private val firebaseService: FirebaseService) : ViewModel() {
    private val _email = MutableStateFlow("")
    val email: StateFlow<String> = _email

    private val _error = MutableStateFlow("")
    val error: StateFlow<String> = _error

    private val _isLoading = MutableStateFlow(false)
    val isLoading: StateFlow<Boolean> = _isLoading

    fun onEmailChange(emailInput: String) {
        _email.value = emailInput
    }

    fun onResetPassword(onSuccess: (email: String) -> Unit) {
        viewModelScope.launch {
            _isLoading.value = true
            val result = sendPasswordResetEmailPlatform(_email.value)
            _isLoading.value = false
            result.onSuccess { onSuccess(_email.value) }
            result.onFailure { err ->
                _error.value = firebaseService.mapErrorMessage(err)
            }
        }
    }
}
